import React from "react";

import { Icon } from "aible";
import Select from "react-select";

import AibleStep from "containers/CreateWizard/AibleStep";

import SelectDataset from "components/CreateWizard/Academic/SelectDataset";
import ProblematicPredictors from "components/CreateWizard/Academic/ProblematicPredictors";

import styles from "./style.module.css";

export default class AcademicChooseDataset extends React.PureComponent {
  render() {
    const {
      blueprintId,
      id,
      isShow,
      options,

      step,
      index,

      datasetView,
      selectedDataset,
      outcomeType,
      updateSelection,
      selectedSuccess,
      successOptions,
      updateSuccess,
      correlations,
      ignored,
      updateIgnored,
      isDataMode
    } = this.props;

    const isRegressionDataset = outcomeType === "number";
    const isSuccessSelected = isDataMode || (selectedDataset && (selectedSuccess || isRegressionDataset));
    const hasProblematicPredictors = correlations && correlations.length > 0;

    return (
      <div className={styles.outcomeOptions} style={{ width: "100%", opacity: isShow === true ? 1 : 0 }}>
        <div id="academicChooseDataset" style={{ width: "100%" }}>
          <AibleStep
            id={id}
            bId="academicChooseDataset"
            message={"Select an outcome"}
            secondaryMessage={
              "Select an outcome Now that you have selected a dataset choose the outcome that you would like to predict."
            }
            isBreak
          >
            <div className={styles.academicDatasetWrapper + " " + styles.chooseSuccessWrapper}>
              <div className={styles.chooseDatasetWrapper} style={selectedDataset ? {} : { width: "100%" }}>
                <div className={styles.chooseDataset} style={selectedDataset ? {} : { width: "100%" }}>
                  <SelectDataset id={id} selectedDataset={selectedDataset} />
                </div>

                {selectedDataset ? (
                  <div className={styles.chooseSuccess}>
                    <div className={styles.selectHeader}>
                      <Icon type={"target"} />
                      <div className={styles.selectHeaderText}>{"Predict:"}</div>
                    </div>
                    <div className={styles.selectLabel}>
                      {selectedDataset.outcome + (isDataMode || isRegressionDataset ? "" : " is:")}
                    </div>
                    {isDataMode || isRegressionDataset ? (
                      ""
                    ) : (
                      <Select
                        key={selectedSuccess ? "success" : "undefined"}
                        value={selectedSuccess}
                        onChange={(value) => updateSuccess(value)}
                        options={successOptions}
                        className={styles.outcomePicker}
                        placeholder="Select Value"
                        menuPlacement="top"
                        isMulti={successOptions && successOptions.length > 2}
                      />
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>
              {selectedDataset && isSuccessSelected ? (
                <div className={styles.correlationWrapper}>
                  <ProblematicPredictors
                    id={id}
                    selectedDataset={selectedDataset}
                    correlations={correlations}
                    updateIgnored={updateIgnored}
                    ignored={ignored}
                    isDataMode={isDataMode}
                    options={options}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
            <div style={{ flexGrow: 1 }} />
          </AibleStep>
        </div>
      </div>
    );
  }
}
